/** @file Bytes of scratch buffers buildOverlay needs for a mesh: the formula its mesh buffers are sized by. */
import { edgeTableSlots } from './layers/edgeTableSlots';

/**
 * Bytes of the buffers buildOverlay sizes for a mesh of `vertexCount` vertices and `triangleIndexCount` triangle
 * indices: 29 B per vertex (skeleton-space f32 x 2, pixels f64 x 2, colour u32, selection mark u8) plus 8 B per
 * edge-key table slot (a power of two, at least 1,024 and at least twice the triangle indices). Nothing else the
 * overlay allocates grows with a mesh. A mesh needing at most 2 MiB is served from the retained scratch (never more
 * than 2 MiB in all); a bigger one gets buffers of these bytes for the build, released when the build ends.
 */
export function overlayScratchBytes(vertexCount: number, triangleIndexCount: number): number {
  return 29 * Math.ceil(Math.max(0, vertexCount)) + 8 * edgeTableSlots(triangleIndexCount);
}
